import type { ClassValue } from "clsx"
import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

// Shadcn stuff
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
